import TableRow from "@mui/material/TableRow";
import { Box, Chip, styled, useTheme } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { Paragraph } from "../components/Typography";
import PayPal from "../images/paypal.png";
import Venmo from "../images/venmo.png";
import { dateFormat, formatMoney } from "../../../common/utils";

import { LiTableCell } from "../components/pieces";
import type { Payout, AppContext } from "../../../types";

const images: Record<string, string> = {
    paypal: PayPal,
    venmo: Venmo,
};

const brandNames: Record<string, string> = {
    paypal: `PayPal`,
    venmo: `Venmo`,
};

const chipMap: Record<string, "success" | "error" | "info"> = {
    Sent: `success`,
    Returned: `error`,
    Canceled: `error`,
    Requested: `info`,
};

interface PayoutTableRowMobileProps {
    payout: Payout;
    context: AppContext;
    onClick: (payout: Payout) => void;
}

const PayoutTableRowMobile = (props: PayoutTableRowMobileProps) => {
    const { payout, context, onClick } = props;
    const MobilePara = styled(Paragraph)(() => ({
        fontSize: `15px`,
    }));
    const theme = useTheme();

    return (
        <TableRow
            selected={false}
            sx={{
                "-webkit-tap-highlight-color": `transparent`,
                border: `none`,
                borderTop: `1px solid #E1E1E1`,
                cursor: `pointer`,
            }}
        >
            <LiTableCell sx={{ padding: `16px`, display: `flex` }}>
                <Box
                    mr="15px"
                    sx={{
                        alignSelf: `center`,
                        maxHeight: `30px`,
                        height: `auto`,
                        maxWidth: 30,
                        width: `auto`,
                    }}
                    component="img"
                    src={payout.icon ? payout.icon : images[payout[`Payout Type`]]}
                />
                <Box>
                    <MobilePara sx={{ margin: 0, fontSize: 12 }}>
                        {dateFormat(payout[`Payout Date`] ?? context.nextFifteen)}
                    </MobilePara>
                    <MobilePara
                        fontWeight={600}
                        sx={{
                            margin: 0,
                            paddingTop: `5px`,
                        }}
                    >
                        {payout.icon ? payout[`Payout Type`] : brandNames[payout[`Payout Type`]]}
                    </MobilePara>
                </Box>
            </LiTableCell>
            <LiTableCell sx={{ padding: `16px`, textAlign: `right`, minWidth: 155 }}>
                <Box sx={{ display: `inline-block`, verticalAlign: `middle` }}>
                    <MobilePara
                        sx={{
                            margin: 0,
                            color: `#333`,
                            fontSize: 12,
                        }}
                    >
                        {formatMoney(payout[`Payout Amount`])}
                    </MobilePara>
                    <MobilePara sx={{ margin: 0, paddingTop: `5px`, fontWeight: 600 }}>
                        <Box
                            sx={{
                                display: `flex`,
                                alignItems: `center`,
                                justifyContent: `center`,
                            }}
                        >
                            <Chip
                                sx={{ padding: `1px 4px 0`, height: 20 }}
                                size="small"
                                label={payout[`Payout Status`]}
                                color={chipMap[payout[`Payout Status`]]}
                            />
                        </Box>
                    </MobilePara>
                </Box>
                {context?.adminConfig!.mall!.CORE_SETTINGS![`Payout Method`] === `Request` && (
                    <Box sx={{ display: `inline-block`, verticalAlign: `middle` }}>
                        {payout[`Payout Status`] === `Requested` && payout.cancelId && (
                            <Delete
                                sx={{ marginLeft: `10px`, color: theme.palette.error.main }}
                                onClick={() => onClick(payout)}
                            />
                        )}
                    </Box>
                )}
            </LiTableCell>
        </TableRow>
    );
};

export default PayoutTableRowMobile;
